import { render } from "./ShareAnnotations.vue?vue&type=template&id=3375cab0&scoped=true"
import script from "./ShareAnnotations.vue?vue&type=script&lang=js"
export * from "./ShareAnnotations.vue?vue&type=script&lang=js"

import "./ShareAnnotations.vue?vue&type=style&index=0&id=3375cab0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3375cab0"]])

export default __exports__